<template>
  <div id="contents" class="view contents" v-if="product">
    <div class="productView">
      <div class="productItem">
        <products-image :imageList="product.productImageList"></products-image>
        <product-item :product="product" :isList="false"></product-item>
        <button
          v-if="product.enableRewardUse"
          type="button"
          class="btShare"
          @click="shareModalToggle"
        >
          <span class="icon iconShareReward"></span>
          <span class="accessibilityHide">{{ $t('shop.share_reward') }}</span>
        </button>
        <button v-else type="button" class="btShare" @click="shareModalToggle">
          <span class="icon iconShare"></span>
          <span class="accessibilityHide">{{ $t('shop.share_B12') }}</span>
        </button>
        <share-modal
          @shareModalToggle="shareModalToggle"
          :shareUrl="product.shareUrl"
          :rewardRate="product.rewardRate"
          :rewardUse="product.enableRewardUse"
          :show="shareModalShow"
          class="modalShare"
        ></share-modal>
      </div>
      <div v-if="product.enableRewardUse" class="productBanner bannerReward">
        <router-link :to="{ name: 'rewardIntro' }">
          <h3>{{ $t('shop.what_is_reward_program') }}</h3>
          <div class="bt">
            <span>{{ $t('shop.learn_more') }}</span>
            <span class="icon iconMore6"></span>
          </div>
        </router-link>
      </div>
      <tag-list-simple :tagList="product.tagList"></tag-list-simple>

      <funding-product-detail
        v-if="product.type === 4"
        :funding="product.funding"
        :fundingAgree="fundingAgree"
        :productStatus="product.productStatus"
        @refreshFundingInfo="refreshFundingInfo"
        @handleCheckFunding="handleCheckFunding"
      />

      <div class="productDetail ql-container ql-snow">
        <div class="ql-editor" v-html="productDetailForA2SLog"></div>
      </div>
    </div>

    <delivery-guide
      v-if="product.type === 3 || product.type === 4"
      :deliveryDesc="product.deliveryDesc"
    />
    <refund-guide
      v-if="product.refundExchangeDesc && product.type !== 7"
      :refundExchangeDesc="product.refundExchangeDesc"
    />
    <products-list-simple
      v-if="product.type !== 7"
      :products="product.popularList"
      :listTitle="$t('shop.related_tag_popular_products_B01')"
    />
    <product-buy-bar :product="product" :fundingAgree="fundingAgree" />
  </div>
</template>

<script>
import ProductAPI from '@/api/product'
import ProductsImage from '@/views/base/ProductsImage'
import ProductItem from '@/views/base/ProductItem'
import TagListSimple from '@/views/shop/TagListSimple'
import ProductsListSimple from '@/views/shop/ProductsListSimple'
import ProductBuyBar from '@/views/shop/ProductBuyBar'
import ShareModal from '@/views/base/ShareModal'
import { mapGetters, mapActions } from 'vuex'
import FundingProductDetail from '@/views/shop/FundingProduct'
import DeliveryGuide from '@/views/shop/DeliveryGuide'
import RefundGuide from '@/views/shop/RefundGuide'
import { beforeSendLog } from '@/utils'

export default {
  name: 'ProductView',
  props: {
    productId: {
      type: String,
      default: ''
    },
    og: {
      type: String,
      default: null
    }
  },
  watch: {
    productId: {
      handler(n, o) {
        if (n) {
          this.product = null
          this.getProductInfo(n)
        }
      }
    }
  },
  components: {
    ProductsImage,
    ProductItem,
    TagListSimple,
    ProductsListSimple,
    ProductBuyBar,
    ShareModal,
    FundingProductDetail,
    DeliveryGuide,
    RefundGuide
  },
  data() {
    return {
      product: null,
      shareModalShow: false,
      fundingAgree: false
    }
  },
  computed: {
    ...mapGetters('main', ['shopId']),
    productDetailForA2SLog() {
      const anchorRegex = /<a\b[^>]*>(.*?)<\/a>/g
      const hrefPattern = /href="([^"]+)"/g

      let html = this.product.productDetail

      const matches = html.match(anchorRegex)

      if (!matches) {
        return html
      }

      const urls = []

      matches.forEach(element => {
        let match

        while ((match = hrefPattern.exec(html)) !== null) {
          urls.push(match[1])
        }

        const url = urls && urls.length > 0 ? urls[0] : ''

        html =
          html.substring(0, html.indexOf(element) + 3) +
          `onclick="interceptor(event, '${encodeURIComponent(url)}')" ` +
          html.substring(html.indexOf(element) + 3)
      })

      return html
    }
  },
  methods: {
    ...mapActions('recent', ['addRecentProducts']),
    getProductInfo(productId) {
      ProductAPI.getProductInfo(productId, this.og, response => {
        this.product = this.og
          ? { og: this.og, ...response.data }
          : response.data
        beforeSendLog('Detail', {
          ProductId: this.product.productId,
          ProductType: this.product.type
        })
        this.addRecentProducts([Number(this.productId)])
      })
    },
    refreshFundingInfo() {
      beforeSendLog('FundingRefresh', {
        ProductId: this.product.productId,
        ProductType: this.product.type
      })
      ProductAPI.getFundingInfo(this.productId, response => {
        this.product = {
          ...this.product,
          funding: response.data
        }
      })
    },
    shareModalToggle() {
      if (this.shopId) {
        beforeSendLog('Share', {
          ShopID: this.shopId
        })
      }
      this.shareModalShow = !this.shareModalShow
    },
    handleCheckFunding() {
      this.fundingAgree = !this.fundingAgree
    }
  },
  mounted() {
    this.getProductInfo(this.productId)
    // 30주년 특정 상점에서 상품 상세 내에 link를 눌렀을 때 로깅을 하고 싶다고 하여 추가된 코드
    // 시간이 촉박한 상황에서 개발되었기 때문에 문제 발생 소지가 있습니다.
    window.interceptor = (e, url) => {
      if (beforeSendLog) {
        beforeSendLog('link', {
          ProductID: this.product.productId,
          ShopID: this.shopId,
          URL: decodeURIComponent(url)
        })
      }
    }
  },
  beforeDestroy() {
    window.interceptor = null
  }
}
</script>

<style lang="scss">
.ql-video {
  width: 608px;
  height: 342px;
}
</style>
